export default function RecommendedController() {

}